export default "__VITE_ASSET__CgX5Tc82__"